import React from "react";
import moment from "moment";

interface DateLabelProps {
  created_at: string | Date;
}

const DateLabel: React.FC<DateLabelProps> = ({ created_at }) => {
  const date = moment.utc(created_at).local();
  const now = moment();
  const diffDays = now.startOf("day").diff(date.startOf("day"), "days");

  let label: string;

  if (diffDays === 0) {
    label = "Today";
  } else if (diffDays === 1) {
    label = "Yesterday";
  } else if (diffDays <= 7) {
    label = `${diffDays} days ago`;
  } else {
    label = date.format("YYYY-MM-DD");
  }

  return <span>{label}</span>;
};

export default DateLabel;
